import { useAllowByPermission } from './useAllowByPermissions';

/** `true` when the session has `is:admin`; `undefined` while permissions load. */
export function useIsAdmin() {
  return useAllowByPermission('is:admin');
}
